export default {
    "created": "Cursul a fost creat cu succes",
    "updated": "Cursul a fost actualizat cu succes",
    "deleted": "Cursul a fost șters cu succes",
    "restored": "Cursul a fost restaurat cu succes",
    'not_found': 'Cursul nu a fost gasit',
    'reminder_sent': 'Notificarea a fost trimisa cu succes',
}
